var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapturePhotoIdCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 150,
    viewBox: "0 0 194 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 130,
    rx: 10,
    fill: "#7A8189"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17573_25390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.3369H176V106H18V21.3369Z",
    fill: "url(#paint0_linear_17573_25390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.257 53.2307C118.257 51.9496 119.393 50.9111 120.795 50.9111H165.847C167.249 50.9111 168.385 51.9496 168.385 53.2307V94.4023C168.385 95.6833 167.249 96.7218 165.847 96.7218H120.795C119.393 96.7218 118.257 95.6833 118.257 94.4023V53.2307Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.866 60.7285C137.503 53.9505 143.614 56.2371 146.491 58.5375C152.125 57.1134 157.175 62.0431 157.639 67.1918C158.478 76.5034 150.327 80.5567 155.242 84.0622C157.411 85.6093 160.969 86.9903 159.102 88.8909C158.132 89.8779 156.867 90.6046 155.601 91.1829C147.86 94.7201 138.279 93.4823 132.945 92.3879C130.17 91.8186 128.385 90.3446 127.325 88.6013C126.199 86.7504 129.736 84.9019 131.627 83.8432C135.343 81.7618 122.756 71.6834 131.866 60.7285Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78 81.542C139.86 82.5644 139.804 84.8065 138.941 85.5953C138.519 85.9813 137.453 86.401 136.118 86.9266C134.044 87.7433 131.32 88.8157 129.351 90.4154C126.762 92.5187 126.194 96.1119 126.234 96.6596H158.84C158.88 96.1119 158.312 92.5187 155.723 90.4154C153.754 88.8157 151.03 87.7433 148.956 86.9266C147.622 86.401 146.556 85.9813 146.133 85.5953C145.27 84.8065 145.214 82.5644 145.294 81.542H139.78Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.533 91.8408C140.615 91.8408 136.66 91.6213 135.222 90.6357C134.334 90.0272 133.616 89.1034 133.109 88.1855C135.686 86.9959 138.229 86.2469 138.941 85.5957C139.804 84.8067 139.86 82.5643 139.78 81.542H142.533V91.8408ZM145.294 81.542C145.214 82.5644 145.27 84.8069 146.133 85.5957C146.845 86.2464 149.384 86.9954 151.959 88.1836C151.453 89.102 150.734 90.0268 149.846 90.6357C148.407 91.6211 144.452 91.8408 142.534 91.8408V81.542H145.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.734 75.3346C151.583 79.7963 147.721 83.9525 143.135 83.9525C138.567 83.9525 134.718 79.8226 133.55 75.3883C133.47 75.4012 133.388 75.4078 133.305 75.4078C132.18 75.4078 131.268 74.1816 131.268 72.6691C131.268 71.1566 132.18 69.9304 133.305 69.9304C133.37 69.9304 133.433 69.9344 133.496 69.9422C134.597 65.4003 138.495 62.043 143.135 62.043C147.791 62.043 151.7 65.4231 152.785 69.9884C152.92 69.9504 153.061 69.9304 153.204 69.9304C154.33 69.9304 155.242 71.1566 155.242 72.6691C155.242 74.1816 154.33 75.4078 153.204 75.4078C153.043 75.4078 152.885 75.3825 152.734 75.3346Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.541 69.7114C142.693 68.7567 145.052 66.8455 145.771 65.0197C146.131 66.1152 147.64 68.0931 149.248 69.073C151.405 70.3875 153.084 70.0589 154.882 69.8398C155.441 69.4746 155.817 68.1966 154.282 65.5674C152.364 62.281 148.648 61.8428 143.254 61.4046C138.939 61.0541 133.824 65.677 131.866 67.8679C131.706 68.1601 130.188 70.6973 136.541 69.7114Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 32.3545H27.0817V39.5501H24.9805V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1828 32.3545H31.284V39.5501H29.1828V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3852 32.3545H35.4864V39.5501H33.3852V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5876 32.3545H39.6887V39.5501H37.5876V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7899 32.3545H43.8911V39.5501H41.7899V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9923 32.3545H48.0935V39.5501H45.9923V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1946 32.3545H52.2958V39.5501H50.1946V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.397 32.3545H56.4982V39.5501H54.397V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3658 86.7712H45.467V93.9668H43.3658V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5682 86.7712H49.6694V93.9668H47.5682V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7705 86.7712H53.8717V93.9668H51.7705V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9729 86.7712H58.0741V93.9668H55.9729V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1753 86.7712H62.2764V93.9668H60.1753V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3776 86.7712H66.4788V93.9668H64.3776V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58 86.7712H70.6812V93.9668H68.58V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7823 86.7712H74.8835V93.9668H72.7823V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5606 86.7712H80.6618V93.9668H78.5606V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.763 86.7712H84.8641V93.9668H82.763V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9653 86.7712H89.0665V93.9668H86.9653V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1677 86.7712H93.2689V93.9668H91.1677V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37 86.7712H97.4712V93.9668H95.37V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5724 86.7712H101.674V93.9668H99.5724V86.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 52.5921H37.258V62.9358H24.9805V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3273 52.5921H43.3967V62.9358H40.3273V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4661 52.5921H49.5355V62.9358H46.4661V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6048 52.5921H59.1272V62.9358H52.6048V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1966 52.5921H65.266V62.9358H62.1966V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3354 52.5921H71.4047V62.9358H68.3354V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4741 52.5921H97.1107V62.9358H74.4741V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.18 52.5921H103.249V62.9358H100.18V52.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 66.9833H37.258V77.327H24.9805V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3273 66.9833H43.3967V77.327H40.3273V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4661 66.9833H49.5355V77.327H46.4661V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6048 66.9833H59.1272V77.327H52.6048V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1966 66.9833H65.266V77.327H62.1966V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3354 66.9833H71.4047V77.327H68.3354V66.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0547 32.3545H70.1559V39.5501H68.0547V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2571 32.3545H74.3582V39.5501H72.2571V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4594 32.3545H78.5606V39.5501H76.4594V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6618 32.3545H82.763V39.5501H80.6618V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8641 32.3545H86.9653V39.5501H84.8641V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0665 32.3545H91.1677V39.5501H89.0665V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2689 32.3545H95.37V39.5501H93.2689V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4712 32.3545H99.5724V39.5501H97.4712V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.868 32.3545H138.97V39.5501H136.868V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.071 32.3545H143.172V39.5501H141.071V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.273 32.3545H147.374V39.5501H145.273V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.475 32.3545H151.577V39.5501H149.475V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.678 32.3545H155.779V39.5501H153.678V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88 32.3545H159.981V39.5501H157.88V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.083 32.3545H164.184V39.5501H162.083V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.285 32.3545H168.386V39.5501H166.285V32.3545Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0623 90.903C37.0623 94.1164 34.3577 96.7214 31.0214 96.7214C27.6851 96.7214 24.9805 94.1164 24.9805 90.903C24.9805 87.6897 27.6851 85.0847 31.0214 85.0847C34.3577 85.0847 37.0623 87.6897 37.0623 90.903Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 158,
    height: 13.3373,
    fill: "#6196C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5062 17.6011H26.9945C27.3767 17.6011 27.7305 17.5379 28.0558 17.4115C28.3893 17.2773 28.678 17.0917 28.922 16.8548C29.1741 16.6179 29.3652 16.3415 29.4953 16.0256C29.6336 15.7097 29.7027 15.3662 29.7027 14.9951C29.7027 14.6239 29.6336 14.2804 29.4953 13.9645C29.3571 13.6407 29.166 13.3604 28.922 13.1235C28.678 12.8866 28.3893 12.701 28.0558 12.5668C27.7305 12.4325 27.3767 12.3654 26.9945 12.3654H25.5062V17.6011ZM23.7373 19.1291V10.8373H27.0189C27.6614 10.8373 28.2551 10.9439 28.8 11.1572C29.3449 11.3625 29.8207 11.6547 30.2273 12.0337C30.6339 12.4128 30.9511 12.855 31.1788 13.3604C31.4147 13.8658 31.5326 14.4107 31.5326 14.9951C31.5326 15.5873 31.4188 16.1322 31.191 16.6297C30.9633 17.1272 30.6421 17.5655 30.2273 17.9446C29.8207 18.3157 29.3449 18.6079 28.8 18.8211C28.2551 19.0265 27.6614 19.1291 27.0189 19.1291H23.7373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3537 19.1291V10.8373H37.5259C38.1033 10.8373 38.6116 10.9479 39.0508 11.169C39.4981 11.3822 39.8437 11.6823 40.0877 12.0693C40.3398 12.4562 40.4659 12.9024 40.4659 13.4078C40.4659 13.9369 40.3154 14.4028 40.0145 14.8055C39.7136 15.2083 39.311 15.5084 38.8068 15.7058L40.6977 19.1291H38.7214L37.0501 15.9545H35.1226V19.1291H33.3537ZM35.1226 14.5449H37.3673C37.7658 14.5449 38.083 14.4423 38.3188 14.237C38.5628 14.0316 38.6848 13.7631 38.6848 13.4315C38.6848 13.0998 38.5628 12.8313 38.3188 12.626C38.083 12.4207 37.7658 12.318 37.3673 12.318H35.1226V14.5449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2434 19.1291V10.8373H44.0123V19.1291H42.2434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8245 19.1291L45.3599 10.8373H47.2752L49.8858 17.3641L52.5574 10.8373H54.3873L50.8739 19.1291H48.8245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7222 19.1291V10.8373H62.2854V12.3299H57.4911V14.2251H60.6507V15.6703H57.4911V17.6366H62.3342V19.1291H55.7222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1949 19.1291V10.8373H68.3671C68.9445 10.8373 69.4528 10.9479 69.892 11.169C70.3393 11.3822 70.6849 11.6823 70.9289 12.0693C71.181 12.4562 71.3071 12.9024 71.3071 13.4078C71.3071 13.9369 71.1566 14.4028 70.8557 14.8055C70.5548 15.2083 70.1522 15.5084 69.648 15.7058L71.5389 19.1291H69.5626L67.8913 15.9545H65.9638V19.1291H64.1949ZM65.9638 14.5449H68.2085C68.607 14.5449 68.9242 14.4423 69.16 14.237C69.404 14.0316 69.526 13.7631 69.526 13.4315C69.526 13.0998 69.404 12.8313 69.16 12.626C68.9242 12.4207 68.607 12.318 68.2085 12.318H65.9638V14.5449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1487 19.1291V10.8373H77.9176V17.6129H82.5899V19.1291H76.1487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.419 19.1291V10.8373H86.1878V19.1291H84.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5615 19.2476C91.9271 19.2476 91.3334 19.141 90.7804 18.9277C90.2274 18.7066 89.7434 18.4026 89.3287 18.0156C88.922 17.6287 88.6008 17.1786 88.3649 16.6653C88.1372 16.1441 88.0234 15.5834 88.0234 14.9832C88.0234 14.3752 88.1372 13.8145 88.3649 13.3012C88.6008 12.78 88.9261 12.3259 89.3409 11.939C89.7556 11.552 90.2355 11.2519 90.7804 11.0387C91.3334 10.8176 91.9271 10.707 92.5615 10.707C93.0332 10.707 93.4886 10.7702 93.9278 10.8966C94.367 11.0229 94.7736 11.2006 95.1477 11.4296C95.53 11.6586 95.8553 11.935 96.1236 12.2588L94.9281 13.4078C94.6191 13.0366 94.2612 12.7563 93.8546 12.5668C93.4561 12.3772 93.025 12.2825 92.5615 12.2825C92.1792 12.2825 91.8214 12.3535 91.4879 12.4957C91.1545 12.6299 90.8658 12.8195 90.6218 13.0643C90.3778 13.3012 90.1867 13.5855 90.0484 13.9171C89.9102 14.2409 89.841 14.5963 89.841 14.9832C89.841 15.3623 89.9102 15.7176 90.0484 16.0493C90.1867 16.3731 90.3819 16.6574 90.634 16.9022C90.8861 17.1391 91.1789 17.3247 91.5123 17.4589C91.8539 17.5932 92.224 17.6603 92.6225 17.6603C93.0698 17.6603 93.4886 17.5695 93.879 17.3878C94.2694 17.2062 94.615 16.9456 94.9159 16.606L96.0748 17.7195C95.8065 18.0354 95.4852 18.3078 95.1111 18.5368C94.737 18.7659 94.3304 18.9435 93.8912 19.0699C93.4601 19.1883 93.0169 19.2476 92.5615 19.2476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.719 19.1291V10.8373H104.282V12.3299H99.4879V14.2251H102.647V15.6703H99.4879V17.6366H104.331V19.1291H97.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.192 19.1291V10.8373H107.875L112.121 16.1915V10.8373H113.78V19.1291H112.218L107.863 13.5855V19.1291H106.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.148 19.2476C119.514 19.2476 118.92 19.141 118.367 18.9277C117.814 18.7066 117.33 18.4026 116.915 18.0156C116.508 17.6287 116.187 17.1786 115.951 16.6653C115.724 16.1441 115.61 15.5834 115.61 14.9832C115.61 14.3752 115.724 13.8145 115.951 13.3012C116.187 12.78 116.513 12.3259 116.927 11.939C117.342 11.552 117.822 11.2519 118.367 11.0387C118.92 10.8176 119.514 10.707 120.148 10.707C120.62 10.707 121.075 10.7702 121.514 10.8966C121.953 11.0229 122.36 11.2006 122.734 11.4296C123.116 11.6586 123.442 11.935 123.71 12.2588L122.515 13.4078C122.206 13.0366 121.848 12.7563 121.441 12.5668C121.043 12.3772 120.612 12.2825 120.148 12.2825C119.766 12.2825 119.408 12.3535 119.074 12.4957C118.741 12.6299 118.452 12.8195 118.208 13.0643C117.964 13.3012 117.773 13.5855 117.635 13.9171C117.497 14.2409 117.428 14.5963 117.428 14.9832C117.428 15.3623 117.497 15.7176 117.635 16.0493C117.773 16.3731 117.968 16.6574 118.22 16.9022C118.473 17.1391 118.765 17.3247 119.099 17.4589C119.44 17.5932 119.81 17.6603 120.209 17.6603C120.656 17.6603 121.075 17.5695 121.465 17.3878C121.856 17.2062 122.201 16.9456 122.502 16.606L123.661 17.7195C123.393 18.0354 123.072 18.3078 122.698 18.5368C122.323 18.7659 121.917 18.9435 121.478 19.0699C121.047 19.1883 120.603 19.2476 120.148 19.2476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.305 19.1291V10.8373H131.869V12.3299H127.074V14.2251H130.234V15.6703H127.074V17.6366H131.917V19.1291H125.305Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.5,
    width: 159,
    height: 99,
    rx: 5.5,
    stroke: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17573_25390)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 110,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#29C26C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.181 122.155C108.832 122.806 108.832 123.864 108.181 124.515L94.8478 137.848C94.1968 138.499 93.1395 138.499 92.4884 137.848L85.8218 131.181C85.1707 130.53 85.1707 129.473 85.8218 128.822C86.4728 128.171 87.5301 128.171 88.1812 128.822L93.6707 134.306L105.827 122.155C106.478 121.504 107.535 121.504 108.186 122.155H108.181Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17573_25390",
    x1: 166.746,
    y1: 15.128,
    x2: 12.8431,
    y2: 112.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6BFC5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17573_25390"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 158,
    height: 98,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17573_25390"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 110,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapturePhotoIdCorrect);
export default __webpack_public_path__ + "static/media/capture-photo-id-correct.72147b63db8f2f77690a1791a1677129.svg";
export { ForwardRef as ReactComponent };